import { defineStore } from 'pinia'
import { PAGE_PARAMS, PAGINATION_PARAMS } from '../pages'
import http from '../helpers/http-call'
import {
  ENDPOINT_URL,
  getDataLang,
  getQuery,
} from '../helpers/api'
import { useAuthStore } from '../auth'

const DEFAULT_DETAIL = {
  press_title: '',
  press_preview: '',
  press_description: '',
  published_date: '',
  press_image: '',
  slug: '',
}

export interface INews {
  press_title: string
  press_preview: string | null
  press_description: string
  published_date: string
  press_image: string | null
  slug: string
}

interface IQueryProps {
  showData?: boolean
  category?: string
  headers?: {
    Authorization?: string
  }
  hotel_id?: number
  lang_id?: number
  page_size?: number
  page?: number
}
interface IQueryDetailProps {
  headers: any
  slug?: string
  showData?: boolean
}

export interface INewsPagination {
  page: number
  page_size: number
  total_page: number
  total_data: number
}
export interface INewsData {
  press: Array<INews>
  pagination: INewsPagination
}

export interface INewsState {
  list: INewsData
  detail: INews
  dataHidden: INews[]
  data: INewsData
  home: INewsData
  loading: boolean
  loadingDetail: boolean
  params: IQueryProps
}

const DATA = {
  press: [],
  pagination: {
    ...PAGINATION_PARAMS,
  },
}

export const useNewsStore = defineStore('news', {
  state: (): INewsState => ({
    list: DATA,
    data: DATA,
    dataHidden: [DEFAULT_DETAIL],
    home: DATA,
    detail: DEFAULT_DETAIL,
    loading: false,
    loadingDetail: false,
    params: PAGE_PARAMS,
  }),
  getters: {
    getList(): INewsState['list'] {
      return getDataLang(this.list, 0, 'press')
    },
    getData(): INewsState['data'] {
      return getDataLang(this.data, 0, 'press')
    },
    getDetail(): INewsState['detail'] {
      return this.detail
    },
  },
  actions: {
    async setList(data: INewsData, isData?: boolean) {
      const params = getQuery()
      this.list = getDataLang(data, Number(params.lang_id), 'press')
      if (isData)
        this.data = getDataLang(data, Number(params.lang_id), 'press')
    },
    async setDataHidden(data: INews[]) {
      const params = getQuery()
      this.dataHidden = getDataLang(data, Number(params.lang_id), 'press')
    },
    async setDetail(query: IQueryDetailProps) {
      const {
        showData,
        slug,
        headers,
      }: IQueryDetailProps = query
      const params = getQuery()
      const useAuth = useAuthStore()
      let data = DEFAULT_DETAIL
      let response: any = {
        data: {},
      }
      if (params?.lang_id)
        delete params.lang_id

      if (!this.loadingDetail) {
        this.loadingDetail = true
        response = await http.call({
          url: `${ENDPOINT_URL}/news/${slug}`,
          headers,
          params,
          method: 'GET',
          data: null,
        })
      }
      if (response?.response?.data?.errorCode === 401) {
        const auth = await useAuth?.setData({ showData: true })
        if (auth?.token) {
          response = await http.call({
            url: `${ENDPOINT_URL}/news/${slug}`,
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params,
            method: 'GET',
            data: null,
          })
        }
      }
      this.loadingDetail = false
      if (response?.data?.data)
        data = getDataLang(response.data?.data, 0, 'press')
      this.detail = data
      if (showData)
        return await data
    },
    async setData(query: IQueryProps, scope: string | null | undefined = null) {
      const {
        showData,
        category,
        page_size,
        page,
        headers,
      }: IQueryProps = query
      const useAuth = useAuthStore()
      const params = getQuery()
      if (category) {
        Object.assign(params, {
          category,
        })
      }
      if (page_size) {
        Object.assign(params, {
          page_size,
        })
      }
      if (page) {
        Object.assign(params, {
          page,
        })
      }
      // if (params?.lang_id && scope === 'home')
      //   delete params.lang_id

      let data = DATA
      let response: any = {
        data: {},
      }
      if (!this.loading) {
        this.loading = true
        response = await http.call({
          url: `${ENDPOINT_URL}/news`,
          headers,
          params,
          method: 'GET',
          data: null,
        })
      }
      this.params = params
      if (response?.response?.data?.errorCode === 401) {
        const auth = await useAuth?.setData({ showData: true })
        if (auth?.token) {
          response = await http.call({
            url: `${ENDPOINT_URL}/news`,
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params,
            method: 'GET',
            data: null,
          })
        }
      }
      if (response?.data?.data)
        data = getDataLang(response.data?.data, 0, 'press')

      if (scope && Object.keys(this).findIndex((el: string) => el === scope) > -1)
        this[scope] = data
      else
        this.data = data

      setTimeout(() => {
        this.loading = false
      }, 1000)
      if (showData)
        return await data
    },
  },
})
